
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

const SubscriptionSuccess = () => {
  const { refreshSubscription } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  
  useEffect(() => {
    const handleSubscriptionSuccess = async () => {
      try {
        // Refresh subscription data in auth context
        await refreshSubscription();
        
        toast({
          title: "Subscription Activated",
          description: "Your subscription has been successfully activated.",
        });
      } catch (error) {
        console.error("Failed to refresh subscription:", error);
        toast({
          title: "Verification Error",
          description: "There was an issue verifying your subscription. Please contact support.",
          variant: "destructive",
        });
      }
    };

    // If we came from a Stripe checkout, refresh the subscription
    if (searchParams.get("subscription") === "success") {
      handleSubscriptionSuccess();
    }
  }, [refreshSubscription, searchParams, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40 px-4">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold mb-2">Subscription Successful!</h1>
        <p className="text-muted-foreground mb-6">
          Your subscription has been successfully activated. You now have access to all premium features.
        </p>
        <Button onClick={() => navigate("/dashboard")} className="w-full">
          Go to Dashboard
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionSuccess;
